import styled from "styled-components"
import elevation from "@irati/ui/src/global/elevation"
import {greys} from "@irati/ui/src/global/colors"
import {minWidthMedia} from "@irati/ui/src/global/media"
import SearchIcon from "./SearchIcon"

const InputWrapper = styled.div`
    height: 40px;
    background: ${greys.white};
    display: flex;
    border: 1px solid ${greys.light};
    border-radius: 5px;
    transition: transform .12s, box-shadow .12s;
    align-items: center;

    ${minWidthMedia.tablet`
      height: 60px;
    `}

    ${(props) => props.hasFocus && `
      ${elevation.twoPxElevation};
      transform: translateY(-4px);
    `}

    ${SearchIcon} {
      margin: 0 15px;
    }
`
export default InputWrapper
